(ns journal-app-client.components.container
  (:require [journal-app-client.utils.common :as common]))

(defn top-section [& argv]
  (let [[props children] (common/argv->props-children argv)]
    (into
      [:section
       (merge
         props
         {:style (merge {:max-width        "min(100%, 80rem)"
                         :margin-top       "40vh"
                         :margin-inline    "auto"
                         :border-radius    "2rem"
                         :padding          "1rem"
                         :overflow         "hidden"
                         :background-color "hsla(var(--scheme-main-hsl), 0.8)"
                         :-webkit-backdrop-filter "blur(0.25rem)"
                         :backdrop-filter " blur(0.25rem)"}
                   (:style props))})]
      children)))